import CollectionDropdown from './CollectionDropdown.container'
export default CollectionDropdown
